import clsx from 'clsx';
import { Button } from 'src/components/Button';
import { Modal } from 'src/components/Modal';
import { ActionType } from 'src/interfaces/action.interface';
import { actionConfig } from 'src/stubs/action.stub';

interface ActionTypeSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (type: ActionType) => void;
  onContinue?: () => void;
  selectedType: ActionType | null;
}

export const ActionTypeSelector = ({
  isOpen,
  onClose,
  onSelect,
  onContinue,
  selectedType,
}: ActionTypeSelectorProps) => {
  return (
    <Modal
      title="Let's create a new action."
      isOpen={isOpen}
      onClose={onClose}
      actionButton={
        <Button
          onClick={() => {
            selectedType && onSelect(selectedType);
            onContinue?.();
          }}
          disabled={!selectedType}
        >
          Continue
        </Button>
      }
    >
      <p className="mb-4">Specify how this action will take place.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.keys(actionConfig)
          .filter((actionType) => !actionConfig[actionType].disabled)
          .map((actionType) => (
            <div
              key={actionType}
              className={clsx(
                'border rounded-lg cursor-pointer',
                'hover:border-primary/25 hover:shadow-md',
                selectedType === actionType
                  ? 'p-1 action-box-selected rounded-lg shadow-md'
                  : 'p-3 m-1 border-neutral-100',
              )}
              onClick={() => onSelect(actionType as ActionType)}
            >
              <div
                className={clsx(
                  'bg-neutral-0',
                  selectedType === actionType && 'p-3 rounded-md h-full',
                )}
              >
                <div className="flex items-start mb-2">
                  <div className="flex mr-2 h-6 justify-center items-center">
                    <img
                      src={`/assets/actions/modal/${actionConfig[actionType].icon}`}
                      alt={actionConfig[actionType].modalLabel}
                      className={clsx(
                        'flex select-none pointer-events-none',
                        actionConfig[actionType].iconStyling,
                      )}
                    />
                  </div>
                  <p className="font-regular">
                    {actionConfig[actionType].modalLabel}
                  </p>
                </div>
                <p className="text-sm text-neutral-500">
                  {actionConfig[actionType]?.description}
                </p>
              </div>
            </div>
          ))}
      </div>
    </Modal>
  );
};
